import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss']
})
export class OrganizationsComponent implements OnInit {
  form: FormGroup;
  isVisible=false;
  constructor(private formBuilder: FormBuilder) { 

    this.form = this.formBuilder.group({
      from: ['', [Validators.required, Validators.email]],
      to: ['info@banan.om', Validators.required],
      subject: ['', Validators.required],
      body: ['', Validators.required]
    });
  }
  onSubmit() {
      // Mark all form controls as touched
  this.form.markAllAsTouched();

  if (this.form.invalid) {
    // Handle form validation errors if any
    return;
  }
    const { from,to, subject, body } = this.form.value;
   // const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    const mailtoLink = `mailto:${to}?from=${encodeURIComponent(from)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  }
  ngOnInit(): void {
  }
chnage(){
  this.isVisible = !this.isVisible;
}
}
